import { getGroupFolder } from './getGroupFolder';

export function getGroupFolderName(groupId: string, folderId: string): string {
    return getGroupFolder(groupId, folderId)?.DisplayName ?? '';
}
